import Vue from 'vue'
import App from './App.vue'//引用App.vue
import router from './router'//引用router文件夹里的index.js路由配置
import ElementUI from 'element-ui'//
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'//引用一些css样式
import '@/assets/css/theme/index.css'//
import request from "@/utils/request";//引用utils文件夹里的reques.js（axiosp配置和拦截器配置）
//main.js是vue项目的核心配置文件

// Vue.config.productionTip = false 是用来关闭 Vue 应用的生产模式下的提示信息。
//在开发环境中，Vue 会在控制台输出一些有用的提示信息，如警告、错误信息等。
//但是在生产环境中，这些信息对用户并不友好，因此需要关闭这些提示信息。
Vue.config.productionTip = false
// Vue.prototype.$request = request 是将一个自定义的 request 方法(utils/request.js)挂载到 Vue 实例的原型上，
//使得每个组件实例都可以通过 this.$request 的方式访问该方法。这种方式可以在多个组件中共享同一个 request 方法，避免了重复代码的编写。
Vue.prototype.$request = request

// Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL 则是将环境变量中定义的 VUE_APP_BASEURL 的值挂载到 Vue 实例的原型上，
//使得每个组件实例都可以通过 this.$baseUrl 的方式访问该值。这种方式可以方便地在不同的环境中切换 baseURL，而不需要修改大量代码

//process.env.VUE_APP_BASEURL是Vue.js框架中的一个全局变量，它是一个环境变量，用于存储前端应用程序的基本URL
//该变量通常在Vue.js项目的根目录中的.env文件或者.env.[mode]文件中设置。
//在项目中使用该变量可以方便地配置不同环境下的基本URL，例如开发环境和生产环境。通过设置不同的基本URL，
//可以方便地调整前端应用程序与后端API之间的连接。同时，在开发过程中也可以使用该变量来模拟不同的API请求，以测试前端应用程序在不同请求下的行为。

//Vue.prototype.$baseUrl是一个Vue实例属性，用于设置前端应用程序的基本url。通常情况下，我们将其设置为后端服务的基本url，以便前端应用程序可以通过该url访问后端服务提供的API接口。
//在Vue应用程序中，我们可以通过Vue.prototype.$baseUrl来访问后端服务提供的API接口，而不需要手动拼接url。这样可以使我们的代码更加简洁和易于维护。
//需要注意的是，Vue.prototype.$baseUrl并不是Vue的内置属性，需要开发人员手动添加。
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL

//这是Vue使用ElementUI框架的一种方式，其中的{size: “small”}是传入ElementUI的配置项，
//用于设置ElementUI组件的默认大小为小号。这个配置项会被自动应用到所有使用了ElementUI组件的地方。
Vue.use(ElementUI, {size: "small"})


//这段代码是使用Vue.js框架创建一个新的Vue实例，其中包含了路由和渲染函数。其中，router是Vue Router的实例，可以用来进行路由的跳转和管理；
//render函数则是Vue.js中用来渲染组件的函数，它可以返回一个VNode节点，表示需要渲染的组件，这里使用的是ES6的箭头函数。
//最后，使用$mount()方法将Vue实例挂载到指定的DOM元素上，这里是'#app'。这样，当页面加载完成后，该Vue实例将会被激活，并且会根据路由信息和组件渲染函数来动态地渲染页面。
new Vue({
    router,
    render: h => h(App)
    
}).$mount('#app')
